module.exports = __webpack_public_path__ + "static/Adieu-Bold-af33cf9b99f1dc48900692552d1aa830.woff";